import { Controller, useFormContext } from 'react-hook-form';
import { useEffectOnce } from 'react-use';
import { useTranslation } from 'next-i18next';
import { RadioGroup, RadioGroupItem } from '@zep/ui/experimental';
export const PlanDueEndContent = () => {
  const {
    t
  } = useTranslation(['subscription']);
  const {
    control,
    resetField
  } = useFormContext();
  useEffectOnce(() => {
    return () => {
      resetField('cancelReason.planDueEndAnswer');
    };
  });
  return <div className="flex flex-col gap-[8px]" data-sentry-component="PlanDueEndContent" data-sentry-source-file="PlanDueEndContent.tsx">
      <p className="text-body-2-m whitespace-pre text-wrap text-gray-600">
        {t('subscription:unsubscribe.4a36e5b1', '1년 이내에 다시 사용할 계획이 있으신가요?')}
      </p>
      <Controller control={control} name="cancelReason.planDueEndAnswer" render={({
      field: {
        onChange,
        value
      }
    }) => <RadioGroup onValueChange={onChange} value={value}>
            <div className="flex flex-col gap-[8px]">
              <div className="flex items-center gap-[8px]">
                <RadioGroupItem value="네" id="yes" />
                <label htmlFor="yes">
                  {t('subscription:unsubscribe.953174ec', '네')}
                </label>
              </div>
              <div className="flex items-center gap-[8px]">
                <RadioGroupItem value="아니오" id="no" />
                <label htmlFor="no">
                  {t('subscription:unsubscribe.82c040f2', '아니오')}
                </label>
              </div>
            </div>
          </RadioGroup>} data-sentry-element="Controller" data-sentry-source-file="PlanDueEndContent.tsx" />
    </div>;
};